
import { Divider, Modal } from "rsuite";
import { char } from "../../../../../utils";
import { appCRUD } from "../../../../../actions/app";
import { useNotification } from "../../../../../utils/notification";

export const StudentVerification = (props) => {
  const { open, setOpen, index, setIndex, loading, setLoading, dataId, data } =
    props;
  const openNotification = useNotification();


  const handleConfirm = () => {
        setLoading(true)
        setTimeout(() => {
            appCRUD
              .patchStudentData(dataId, { is_verified: true })
              .then(() => {
                openNotification(
                  "success",
                  "Success",
                  <>
                    Thank you..!
                    <br />
                    Student has been verified successfully..!
                  </>
                );
                setIndex(index+1)
                setOpen(false);
              })
              .catch((error) => {
                const responseData = error?.response?.data;
                let errorMessage = "Something went wrong. Please try again.";
                if (typeof responseData === "string") {
                  errorMessage = responseData;
                } else if (responseData?.error) {
                  errorMessage = responseData.error;
                } else if (responseData?.detail) {
                  errorMessage = responseData.detail;
                } else if (responseData?.message) {
                  errorMessage = responseData.message;
                } else if (typeof responseData === "object") {
                  const firstKey = Object.keys(responseData)[0];
                  const firstError = responseData[firstKey];
                  if (Array.isArray(firstError)) {
                    errorMessage = `${firstError[0]}`;
                  }
                }
                openNotification(
                  "error",
                  "Error",
                  <>
                    Sorry...!
                    <br />
                    {errorMessage}
                  </>
                );
              })
              .finally(() => {
                setLoading(false);
              });
        },500)


  }
  

  

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="sm"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Student Confirmation</Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">
                      Registration No.
                    </p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.registration_number
                        ? data.registration_number
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row mt-2">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">Full Name</p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.name ? char.toTitleCase(data.name) : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">
                      Phone Number
                    </p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.phone_number ? data.phone_number : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">Email.</p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.email ? data.email : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">
                      Academic Year
                    </p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.academic_year ? data.academic_year : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">Study Year</p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.study_year
                        ? (() => {
                            switch (data.study_year) {
                              case 1:
                                return "First Year";
                              case 2:
                                return "Second Year";
                              case 3:
                                return "Third Year";
                              case 4:
                                return "Fourth Year";
                              case 5:
                                return "Fifth Year";
                              default:
                                return "N/A";
                            }
                          })()
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">
                      Qualification Level.
                    </p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <p className="text-dark fw-bold fs-13">
                      {data?.level ? data.level : "N/A"}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <p className="h6 fs-14 fw-bold text-primary">Status.</p>
                  </div>
                  <div className="col-1">
                    <p className="text-dark fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    {data?.is_qualified ? (
                      <span class="badge badge-soft-success badge-border fs-13">
                        {char.toTitleCase("Qualified")}
                      </span>
                    ) : (
                      <span class="badge badge-soft-danger badge-border fs-13">
                        {char.toTitleCase("Not Qualified")}
                      </span>
                    )}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={() => setOpen(false)}
                  type="button"
                  className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                >
                  <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                  disabled={loading || !data?.is_qualified}
                  onClick={() => handleConfirm()}
                >
                  {!loading && (
                    <span className="indicator-label">
                      <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                      Confirm
                    </span>
                  )}
                  {loading && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
